<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item class="px-0" two-line>
            <v-list-item-content>
              <v-list-item-title> เพิ่มพนักงาน </v-list-item-title>
              <v-list-item-subtitle v-if="companyFeature.feature">
                {{ companyFeature.feature.title_th }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content v-if="companyFeatureEmployee.employee">
            <v-list-item-title>
              {{
                `${companyFeatureEmployee.employee.firstname_th} ${companyFeatureEmployee.employee.lastname_th}`
              }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="companyFeature.feature">
              {{ companyFeature.feature.title_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <v-autocomplete
          tabindex="1"
          class="fix-google-chrome"
          :readonly="formAction === 'edit'"
          :value="companyFeatureEmployee.employee.employee_uuid"
          :rules="[(v) => !!v || 'โปรดระบุพนักงาน']"
          :items="employees"
          return-object
          item-text="firstname_th"
          item-value="employee_uuid"
          @change="selectedEmployee($event)"
        >
          <template #label>
            พนักงาน
            <span class="red--text"><strong>* </strong></span>
          </template>
          <template v-slot:selection="{ item }">
            {{ `${item.firstname_th} ${item.lastname_th}` }}
          </template>
          <template v-slot:item="{ item }">
            <template>
              <v-list-item-content>
                <v-list-item-title>
                  {{ `${item.firstname_th} ${item.lastname_th}` }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-1">
                  <div>
                    รหัสพนักงาน:
                    <span class="black--text">{{ item.employee_code }}</span>
                  </div>
                  <div class="mt-1">
                    ชื่อหน่วยงาน:
                    <span class="black--text">{{
                      item.organization.title_th
                    }}</span>
                  </div>
                  <v-divider class="mt-2"></v-divider>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
        <v-text-field
          v-if="companyFeatureEmployee.employee.employee_code"
          :value="companyFeatureEmployee.employee.employee_code"
          readonly
          class="fix-google-chrome"
          label="รหัสพนักงาน"
        ></v-text-field>
        <v-text-field
          v-if="companyFeatureEmployee.employee.organization"
          :value="companyFeatureEmployee.employee.organization.title_th"
          readonly
          class="fix-google-chrome"
          label="หน่วยงาน"
        ></v-text-field>
        <div class="d-sr-only">{{ isCompanyFeatureEmployeeDataChange }}</div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center" v-if="formAction === 'edit'">
          <v-btn icon @click="onDelete">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn tabindex="2" class="primary mr-3" depressed @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: Boolean,
    formAction: String,
    companyFeature: Object,
    companyFeatureEmployee: Object,
    companyFeatureEmployeeInit: Object,
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    isCompanyFeatureEmployeeDataChange() {
      if (
        this.companyFeatureEmployee.employee.employee_uuid !==
        this.companyFeatureEmployeeInit.employee.employee_uuid
      ) {
        this.$emit('isCompanyFeatureEmployeeDataChange', true)
        return true
      }
      this.$emit('isCompanyFeatureEmployeeDataChange', false)
      return false
    },
    employees() {
      return this.$store.state.employee.employees
    },
  },
  methods: {
    ...mapActions({
      addEmployeeFeatureToggle: 'feature/addEmployeeFeatureToggle',
      deleteEmployeeFeatureToggle: 'feature/deleteEmployeeFeatureToggle',
    }),
    selectedEmployee(event) {
      if (!event) {
        this.$emit('selectedEmployee', {})
      } else {
        this.$emit('selectedEmployee', {
          ...event,
          organization: {
            ...event.organization,
            title_th: event.organization.title_th,
          },
        })
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบพนักงานออกจากฟีเจอร์',
        value: `${this.companyFeature.feature.title_th}: ${this.companyFeatureEmployee.employee.firstname_th} ${this.companyFeatureEmployee.employee.lastname_th}`,
        item: this.companyFeatureEmployee.employee_feature_toggle_uuid,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(employee_feature_toggle_uuid) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteEmployeeFeatureToggle({
        company_uuid,
        employee_feature_toggle_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_feature_toggle: {
            employee_uuid: this.companyFeatureEmployee.employee.employee_uuid,
            company_feature_toggle_uuid:
              this.companyFeature.company_feature_toggle_uuid,
          },
        }

        this.addEmployeeFeatureToggle(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isCompanyFeatureEmployeeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      this.$emit('onReset', this.formAction)
      this.$refs.form.reset()
    },
  },
}
</script>
